import { createIcon } from '@chakra-ui/icon';
import React from 'react';

export const StoreIcon = createIcon({
  path: (
    <g fill="currentColor">
      <rect x="21.333" y="21.333" width="341.333" height="42.667" />
      <path
        d="M362.667,85.333H21.333L0,192v42.667h21.333v128h213.333v-128H320v128h42.667v-128H384V192L362.667,85.333z M192,320H64
				v-85.333h128V320z"
      />
    </g>
  ),
  viewBox: '0 0 384 384',
});
